import { render, staticRenderFns } from "./ViolationrecordList.vue?vue&type=template&id=345b0e03"
import script from "./ViolationrecordList.vue?vue&type=script&lang=js"
export * from "./ViolationrecordList.vue?vue&type=script&lang=js"
import style0 from "./ViolationrecordList.vue?vue&type=style&index=0&id=345b0e03&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports